// extracted by mini-css-extract-plugin
export default {"addFileButtonsBox":"styles_addFileButtonsBox__oRBLu","image360":"styles_image360__KJ6Xn","audio":"styles_audio__5afN5","image3D":"styles_image3D__-1Yvo"};